const SPACE = 4;

export const spacing = (space: number) =>
  `${(space * SPACE * 0.1).toFixed(3)}rem`;
